export default {
    "appName": "Kobowork",
    "appEmail": "business@kobowork.com",
    "domain": process.env.NODE_ENV === 'production' ? "https://www.kobowork.com" : "http://127.0.0.1:8000",
    "title": "Kobowork | Platform Design Agency for Businesses",
    "shortDesc": "Platform Design Agency for Businesses",
    "description": "Kobowork is a platform design agency for businesses, connecting modern visual designers with you. We are the best place to get the pro designers and creative experts competing to create awesome designs for you!",
    "localUserKey" : "buy_web_udt_mk",
}
